import React from "react";
import FileUpload from "../../../../../components/FileUpload";
import arrowIcon from "../../../../../assets/images/arrow-button.svg";
import SimpleRow from "../../../../../components/SimpleRow";
import AuditReportDrawer from "../../../../../components/AuditReportDrawer";

const Files = () => {
  const data = [
    {
      title: "Upload Data for Audit",
      description:
        "This agreement is made between the participant and the service provider under the National Disability Insurance Scheme (NDIS).",
    },
    {
      title: "Upload Data for AI Training",
      description:
        "Upload documents that the AI can learn from, such as NDIS policies, legislative guidelines, procedures, or case examples.",
    },
  ];

  const list = [
    {
      title: "NDIS Audit Information",
    },
    {
      title: "NDIS Audit Corrective Action Table ",
    },
    {
      title: "NDIS Audit Corrective Action - Certifi Review & Acceptance",
    },
    {
      title: "NDIS Audit Non-Conformity Rating",
    },
    {
      title: "NDIS Audit Corrective Action Timeframe",
    },
  ];

  return (
    <>
      <div className="titleHeader">
        <img src={arrowIcon} alt="Arrow" />
        <p>Document Name Audit Report</p>
      </div>
      <div className="listBox">
        {list.map((v, i) => {
          return <SimpleRow key={i} index={i} data={v} />;
        })}
      </div>
      <div className="filesTabContainer">
        <Component data={data[0]} />
        <Component data={data[1]} />
      </div>
      <AuditReportDrawer />
    </>
  );
};

const Component = ({ data }) => {
  return (
    <div className="fileColumn">
      <div className="textBox">
        <h2>{data.title}</h2>
        <p>{data.description}</p>
      </div>
      <FileUpload />
    </div>
  );
};

export default Files;
